export default __webpack_public_path__ + "static/eye_wash_b.1a7189dc0fd39e0255f251ab3049421a.svg";